import type { PropType } from 'virtual-vue';
import type { KeysType, RadioOption } from './radio';

/**
 * radio-group组件的props
 */
export const radioGroupProps = {
  /**
   * 是否允许取消选中
   * @default false
   */
  allowUncheck: {
    type: Boolean,
    default: false,
  },

  /**
   * 是否禁用全部子单选框
   */
  disabled: Boolean,

  /**
   * 字段别名映射，允许自定义选项数组中value、label、disabled字段的key，比如{ value: 'myValue', label: 'myLabel', disabled: 'myDisabled'}
   */
  keys: {
    type: Object as PropType<KeysType>,
  },

  /**
   * 单选组件按钮形式
   */
  options: {
    type: Array as PropType<Array<RadioOption>>,
  },

  /**
   * 选中的值 (兼容旧版本)
   */
  value: {
    type: [String, Number, Boolean] as PropType<string | number | boolean>,
  },

  /**
   * 选中的值 (Vue 3 v-model)
   */
  modelValue: {
    type: [String, Number, Boolean] as PropType<string | number | boolean>,
  },

  /**
   * radio组件底部分割线右边距是否占满
   * @default true
   */
  marginLess: {
    type: Boolean,
    default: true,
  },
};
